import React from 'react';
import ReactDOM from 'react-dom/client';
import Chat from './components/Chat';
import { UserProvider } from './userContext';
import './App.css';

// Widget component that wraps your Chat
function ChatWidget({ client }) {
  return (
    <UserProvider>
      <div className="chatbot-widget">
        <Chat />
      </div>
    </UserProvider>
  );
}

// Function to initialize the widget
function initChatWidget(containerId = 'chatbot-widget', options = {}) {
  console.log('Initializing ChatWidget with options:', options);
  const container = document.getElementById(containerId);
  if (container) {
    const client = options.client;
    
    // Set URL params for Chat component
    if (client && typeof window !== 'undefined') {
      const url = new URL(window.location);
      url.searchParams.set('client', client);
      window.history.replaceState({}, '', url);
      console.log('Set URL parameter client=', client);
    }
    
    const root = ReactDOM.createRoot(container);
    root.render(<ChatWidget client={client} />);
    console.log('ChatWidget rendered successfully');
    return true;
  } else {
    console.error('Container not found:', containerId);
  }
  return false;
}

// Make it globally available immediately
if (typeof window !== 'undefined') {
  window.ChatWidget = {
    init: initChatWidget
  };
  console.log('ChatWidget made available globally');
}

export default ChatWidget;